import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { RoleGuard } from './shared/guards/role.guard';
import { UserRole } from './shared/interfaces/user.interface';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => {
      return import('./modules/auth/auth.routes').then((m) => m.authRoutes);
    },
  },
  {
    path: 'admin-panel',
    canActivate: [AuthGuard, RoleGuard],
    data: { roles: [UserRole.ADMIN, UserRole.SUPER_ADMIN] },
    loadChildren: () => {
      return import('./modules/admin-panel/admin-panel.routes').then((m) => m.adminPanelRoutes);
    },
  },
  {
    path: 'projects',
    canActivate: [AuthGuard],
    loadChildren: () => {
      return import('./modules/projects-monitoring/projects-monitoring.routes').then(
        (m) => m.projectsMonitoringRoutes,
      );
    },
  },
  {
    path: 'error',
    loadComponent: () => {
      return import('../app/components/error-page/error-page.component').then(
        (c) => c.ErrorPageComponent,
      );
    },
  },
  { path: '', redirectTo: 'projects', pathMatch: 'full' },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
